export default __webpack_public_path__ + "static/media/edit-solid-black.1a632900.svg";